//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { buyerShowList } from "@/api/buyerShow"
export default {
  data() {
    return {
      sunbathingList: [],
      loadmore: false,
      imgUrl: "https://img.reflower.com.cn/",
      miscurl: "https://misc.reflower.com.cn/",
      id: ""
    };
  },

  components: {},

  computed: {},

  created() {
    this.id = this.$route.query.id
    this.getBuyerShowPage()
  },

  mounted() { },

  methods: {
    getBuyerShowPage() {
      this.loadmore = true
      let params = {
        id: this.id
      }
      buyerShowList(params).then(res => {
        this.loadmore = false
        for (let item in res.data) {
          let obj = res.data[item];
          obj.userImg = this.getRandomInt(1, 10);
          if (obj.picUrls.includes(',')) {
            obj.picUrls = obj.picUrls.split(',')[0]
          }
          this.sunbathingList.push(obj);
        }
      })
    },
    //获取随机数
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    goToProduct(item1) {
      this.$router.push({
        path: "/goodDetails",
        query: {
          gid: item1.signGid,
          utm_source: "scmjx"
        }
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/view/buyersShow/buyerShowPage.vue